import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';

@Injectable()
export class CommunicationServiceProvider {
  private instance: Rx.Subject<any>;

  constructor(public http: HttpClient) {
  }
  createInstance(): Rx.Subject<any> {
    const instance = new Rx.Subject<any>();
    return instance;
  }

  public getInstance(): Rx.Subject<any> {
    if (!this.instance) {
      this.instance = this.createInstance();
    }
    return this.instance;
  }
}



// WEBPACK FOOTER //
// ./src/providers/communication-service/communication-service.ts